import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../routes.json';
import WellnesIco from '../../assets/images/icons/wellness.svg';
import AromaIco from '../../assets/images/icons/aromaterapie.svg';
import MassIco from '../../assets/images/icons/masaze.svg';

import DropAromaOutline from '../../assets/images/hero/drop_aro_outline.svg';
import DropMassOutline from '../../assets/images/hero/drop_mass_outline.svg';
import DropWellOutline from '../../assets/images/hero/drop_well_outline.svg';

const HomepageHero = () => {
  return (
    <div className="row homepage-hero">
      <div className="container">
        <h1 className="headline">
          Aromarea
        </h1>
        <p className="text">
          Vůně nezná hranic. Dokáže nás přenést přes bariéru prostoru i času. 
          Pokud je vhodně zvolená, nabídne vám chráněné místo, 
          ve kterém naleznete:
        </p>
        <span className="subheadline">
          uvolnění  ~  energii  ~  odpovědi
        </span>
        <div className="hero-nav">
          <div className="drop drop-wellness">
            <img src={DropWellOutline} alt="aromatherapy drop outline" className="drop-outline" />
            <Link to={routes.WELLNESS} className="link">
              <span className="text">wellness</span>
              <img className="ico" src={WellnesIco} alt="wellness" />
              <span className="btn btn-default">Vstoupit</span>
            </Link>
          </div>
          <div className="drop drop-aromatherapy">
            <img src={DropAromaOutline} alt="aromatherapy drop outline" className="drop-outline" />
            <Link to={routes.AROMATHERAPY} className="link">
              <span className="text">aromaterapie</span>
              <img className="ico" src={AromaIco} alt="aromaterapie" />
              <span className="btn btn-default">Vstoupit</span>
            </Link>
          </div>
          <div className="drop drop-massage">
            <img src={DropMassOutline} alt="aromatherapy drop outline" className="drop-outline" />
            <Link to={routes.MASSAGE} className="link">
              <img className="ico" src={MassIco} alt="masáže" />
              <span className="text">masáže</span>
              <span className="btn btn-default">Vstoupit</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomepageHero;